import styled from 'styled-components';
import StrippedButton from '../StrippedButton';

export const TabButton = styled(StrippedButton)<{ isActive?: boolean }>`
  font-family: var(--font-sans);
  font-size: 1.25rem;

  ${({ isActive }) => isActive && `font-weight: 500;`}
`;
